<template>
	<div class="charts">
		<scrollbar class="charts__scrollbar">
			<div class="charts__row charts__row--row charts__row--wrap">
				<div class="charts__item charts__item--h50" v-for="(item,index) in years" :key="index">
					<chart-profit
						:year="item"
						@switchMode="switchMode"
						:switchModeIcon="switchIcon[index]"
					>
					</chart-profit>
				</div>
			</div>
		</scrollbar>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import SingleProfitChart from "./singleProfitChart";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
    components: {
        'chart-profit':SingleProfitChart,
		"scrollbar":VuePerfectScrollbar,
    },
    props: {
        update:{default:true},
        updateHeight:{default:true},
        updateRight:{default:true},
        fullStatus:{default:false}
    },
    data() {
        return {
            nowDate: new Date(),
            switchIcon:[false, true, false, false]
        }
    },
    computed: {
        ...mapGetters({
            getProfitMonth:'accountstat/getMonthProfitStrategy'
        }),
        years() {
            if(this.getProfitMonth('') === null)
                return
            let years = getYears(this.getProfitMonth(''));
            return years;
        }
    },
    methods: {
        switchMode() {
            this.$emit('switchMode');
        }
    },
    created() {

    },
}
function getYears(stat) {
    let result = [];
    nextInput:
        for (let i = 0; i < stat.length; i++) {
            let str = stat[i].year;
            for (let j = 0; j < result.length; j++)
                if (result[j] == str) continue nextInput;
            result.push(str);
        }
    return result;
}

</script>
<style lang="less" scoped>
.prof-grid {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    &_wrap {
        //height: calc(100vh - 610px);
        flex-grow: 1;
        flex-basis: 50%;
        display: flex;
        flex-direction: column;
        margin-bottom: 1px;
        flex-wrap: wrap;
        justify-content: center;
        @media screen and (max-width: 1366px) {
            min-height: calc(100vh - 450px);
        }
        &-full {
            min-height: 50%;
        }
    }
    &_row {
        flex-grow: 2;
        display: flex;
        flex-wrap: wrap;
        max-width: 100%;
        max-height: 100%;
    }
    &_item {
        flex-grow: 1;
        flex-basis: 49%;
        max-width: 50%;
        max-height: 50%;
        margin-right: 1px;
        overflow: hidden;
        margin-bottom: 0.5px;
    }
}
</style>
